export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_FAILURE = 'AUTH_FAILURE'
export const AUTH_ERROR   = 'AUTH_ERROR'
export const AUTH_LOGOUT  = 'AUTH_LOGOUT'
export const AUTH_SERVICE_ERROR = 'AUTH_SERVICE_ERROR'
export const TOKEN_REFRESH = 'TOKEN_REFRESH'
export const TOKEN_REFRESH_SUCCESS = 'TOKEN_REFRESH_SUCCESS'